import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Navbar } from "../components/Navbar";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/data";
import { LineChart } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const u = await login(email, password);
      const dest = location.state?.from || (u.role === "admin" ? "/admin" : "/members");
      navigate(dest);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div>
      <Navbar />
      <div className="max-w-md mx-auto px-6 py-20">
        <LineChart className="h-8 w-8 text-[#00B368] mb-4" />
        <h1 className="font-display text-3xl tracking-tight text-[#0A1914] mb-2">Welcome back</h1>
        <p className="text-sm text-gray-600 mb-8">Log in to access your courses and weekly payouts.</p>
        <form onSubmit={submit} className="space-y-4" data-testid="login-form">
          <div>
            <label className="text-xs font-mono uppercase tracking-wider text-gray-500">Email</label>
            <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="w-full mt-1 border border-gray-300 rounded-sm px-3 py-2.5 focus:border-[#00B368] focus:ring-1 focus:ring-[#00B368]/20 outline-none" />
          </div>
          <div>
            <label className="text-xs font-mono uppercase tracking-wider text-gray-500">Password</label>
            <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="w-full mt-1 border border-gray-300 rounded-sm px-3 py-2.5 focus:border-[#00B368] focus:ring-1 focus:ring-[#00B368]/20 outline-none" />
          </div>
          {error && <p data-testid="login-error" className="text-sm text-red-600">{error}</p>}
          <button data-testid="login-submit" disabled={loading} className="w-full bg-[#0A1914] text-white py-3 rounded-sm hover:bg-[#00B368] transition-colors disabled:opacity-50">{loading ? "Logging in..." : "Log in"}</button>
        </form>
        <p className="text-sm text-gray-600 mt-6">No account? <Link to="/register" className="text-[#00B368] hover:underline">Create one</Link></p>
      </div>
    </div>
  );
}
